<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demand-forecast">
    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card title="Sale Trend &amp; Opportunity" subtitle="Actual and Predicted Sale by Week">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="chart.chartOptions"
              :series="chart.series"
            />
          </div>
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <div class="vx-col w-full md:w-1/3 mb-base"></div>
    </div>
  </div>
</template>

<script>
// import AddNewDataSidebar from '@/app/shared../views/ui-elements/data-list/AddNewDataSidebar.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";

import analyticsData from "./analyticsData.js";
import ChangeTimeDurationDropdown from "@/app/shared/components/ChangeTimeDurationDropdown.vue";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  components: {
    // AddNewDataSidebar,
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    DateRangePicker
  },
  data() {
    return {
      trendLineChart: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          annotations: {
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                x: new Date("26 Jul 2020").getTime(),
                strokeDashArray: 0,
                borderColor: "#FEB019",
                label: {
                  borderColor: "#FEB019",
                  style: {
                    color: "#fff",
                    background: "#FEB019"
                  },
                  // text: "Demand"
                }
              },
              {
                x: new Date("19 Jul 2020").getTime(),
                // x2: new Date("19 Apr 2020").getTime(),
                borderColor: "#FEB019",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#FEB019",
                  style: {
                    color: "#fff",
                    background: "#FEB019"
                  },
                  // orientation: "horizontal",
                  text: "Prediction Week"
                }
              }
            ],
            points: [
              {
                x: new Date("26 Jul 2020").getTime(),
                // y: 10000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  },

                  // text: "Prediction Week...."
                }
              }
            ]
          },
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 4, 0, 4, 0, 4],
            width: [2, 2, 2, 2, 2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              offsetY: 10,
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return (val > 999 || val < -999)
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      }
    }
  },
  computed: {
    chart() {
      return this.makeUnitStatsData();
    }
  },
  methods: {
    makeUnitStatsData() {
      let series = [];
      let chartData = {};
      Object.assign(chartData, this.trendLineChart);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let filteredUnitDataTrend = {
          name: "",
          data: []
        };
        let filteredUnitDataPredict = {
          name: "",
          data: []
        };

        filteredUnitDataTrend.name = this.artefact.tags[i].tag + " ~ Sale";
        filteredUnitDataPredict.name = this.artefact.tags[i].tag + " ~ Predicted";

        let filteredActual = this.filterAndSortData(
          this.artefact.tags[i],
          this.artefact.res.trend,
          "actual"
        );

        let filteredPredict = this.filterAndSortData(
          this.artefact.tags[i],
          this.artefact.res.trend,
          "prediction"
        );

        let maxWeeksActual = filteredActual.length;
        let maxWeeksPredict = filteredPredict.length;
        if(maxWeeksActual > 0) {
          filteredUnitDataTrend.data = this.buildseriesOfGroup("actual", maxWeeksActual, filteredActual, filteredActual[0].sale_year);
          series.push(filteredUnitDataTrend);
        }
        if(maxWeeksPredict > 0) {
          filteredUnitDataPredict.data = this.buildseriesOfGroup("predict", maxWeeksPredict, filteredPredict, filteredPredict[0].sale_year);
          series.push(filteredUnitDataPredict);
        }
/*
        let predictionWeekStartDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksActual-1].sale_year)
            .isoWeek(filteredPredict[maxWeeksActual-1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

        let predictionWeekEndDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksPredict - 1].sale_year)
            .isoWeek(filteredPredict[maxWeeksPredict - 1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY'); 
            
        let predictionWeekStart = new Date(predictionWeekStartDate).getTime();
        let predictionWeekEnd = new Date(predictionWeekEndDate).getTime();            

        this.trendLineChart.chartOptions = {
          ...this.trendLineChart.chartOptions,
          annotations: {
            ...this.trendLineChart.chartOptions.annotations,
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                // x: predictionWeekEnd,
                x: predictionWeekStart,
                borderColor: "#2698FF",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  // orientation: "horizontal",
                  text: "Prediction Week"
                }
              }
            ],
            points: [
              {
                x: predictionWeekEnd,
                // y: 15000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  }

                  // text: "Prediction Week"
                }
              }
            ]
          }
        };
*/
        // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      }

      this.trendLineChart.series = series;
      // chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return this.trendLineChart;
    },
    filterAndSortData(tag, data, type) {
      // let filteredData = data.filter(t =>
      //   ((t.store_code
      //     ? tag.code === t.store_code
      //     : tag.tag === t.product_category) && t.type === type)
      // );

      let filteredData = data.filter(t =>
        ((t.store_code
          ? tag.code === t.store_code
          : tag.tag === t.product_category) && (type !== 'prediction' ? (t.type === type) : true))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },

    buildseriesOfGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");

          let fieldToFetch = type+'_qty';

          let y = groupedUnit[weekIndex].revenue
            ? groupedUnit[weekIndex].revenue || 0
            : groupedUnit[weekIndex][fieldToFetch] || 0;

          series.push({
            x: x,
            y: Math.floor(y)
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(++currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },
  },
  created() {},
  mounted() {
    // this.makeUnitStatsData();
  }
};
</script>

<style lang="scss">
#demand-forecast {
  .reportrange-text {
    background: transparent;
    cursor: pointer;
    padding: 0px;
    border: 0px;
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      // border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
